package com.eladfinish.bible.contest.screens.openQuestions.usecases

class ValidateEmailUseCase {

    // NOTE: only escape characters from ECMAScript's SyntaxCharacter set (^ $ \ . * + ? ( ) [ ] { } |)
    // here. Kotlin/JVM's regex engine tolerates backslash-escaping any punctuation as a harmless
    // no-op (e.g. \_, \%, \@), but Kotlin/JS's Regex uses the native unicode-mode RegExp, which
    // throws a SyntaxError ("Invalid escape") for an escaped character outside that set.
    private val emailRegex =
        ("[a-zA-Z0-9+._%-]{1,256}" +
                "@" +
                "[a-zA-Z0-9][a-zA-Z0-9-]{0,64}" +
                "(" +
                "\\." +
                "[a-zA-Z0-9][a-zA-Z0-9-]{0,25}" +
                ")+"
                ).toRegex()

    operator fun invoke(email: String): Boolean {
        return email.isNotEmpty() && emailRegex.matches(email)
    }

}
